// Comparaison de versions « 1.0.3 ». Fichier pur, sans import : la même règle
// est réécrite côté Deno (supabase/functions/_shared/clientVersion.ts) et
// testée avec les mêmes cas.

const VERSION_FORMAT = /^\d+(\.\d+){0,3}$/;

/** Segments numériques d'une version, ou null si elle sort du format. */
export function parseVersion(value: unknown): number[] | null {
  if (typeof value !== "string" || !VERSION_FORMAT.test(value)) return null;
  return value.split(".").map(Number);
}

/** -1, 0 ou 1 ; null dès qu'un côté est illisible. Un segment manquant vaut 0. */
export function compareVersions(a: unknown, b: unknown): -1 | 0 | 1 | null {
  const left = parseVersion(a);
  const right = parseVersion(b);
  if (!left || !right) return null;
  for (let i = 0; i < Math.max(left.length, right.length); i += 1) {
    const diff = (left[i] ?? 0) - (right[i] ?? 0);
    if (diff !== 0) return diff < 0 ? -1 : 1;
  }
  return 0;
}

/** Illisible d'un côté ou de l'autre = false : jamais de rappel à tort. */
export function isBelowMinimum(current: unknown, minimum: unknown): boolean {
  return compareVersions(current, minimum) === -1;
}
